<template>
    <div>
        <b-modal
            :id="modalId"
            :ref="modalId"
            :lazy="true"
            @hidden="hidden"
            :title="`${title} - ${isInvoice ? 'Invoice' : 'Estimate'} Item`"
            no-close-on-backdrop
            title-tag="h2"
            content-class="overflow-visible create-invoice-item"
        >
            <div v-if="warningMessagePayment">
                <div class="alert-wrapper">
                    <div
                        class="alert alert-warning alert-dismissible"
                        role="alert"
                    >
                        {{ warningMessagePayment }}
                    </div>
                </div>
            </div>

            <loader-list v-if="isDataLoading" />

            <createItemMultiplePatient
                v-if="!isSinglePatient"
                id="createItemPage"
                ref="createItemPage"
                v-show="!isDataLoading && page == 'createItemPage'"
                @is-has-record-page="data => (isHasRecordPage = data)"
                @is-type-has-record-page="data => (isTypeHasRecordPage = data)"
                @can-proceed="data => (canProceed = data)"
                @is-button-text-continue="data => (isButtonTextContinue = data)"
                @loading="data => (loading = data)"
                @scroll-top="scrollTop"
                @temporary-disable-button="data => (tempLoading = data)"
                @update-lot="data => (updateLot = data)"
                :isInvoice="isInvoice"
                :invoiceItem="invoiceItem"
                :addNew="addNew"
                :isSaving="loading"
                :isDuplicate="isDuplicate"
            />
            <createItem
                v-if="isSinglePatient"
                id="createItemPage"
                ref="createItemPage"
                v-show="!isDataLoading && page == 'createItemPage'"
                @is-has-record-page="data => (isHasRecordPage = data)"
                @is-type-has-record-page="data => (isTypeHasRecordPage = data)"
                @can-proceed="data => (canProceed = data)"
                @is-button-text-continue="data => (isButtonTextContinue = data)"
                @loading="data => (loading = data)"
                @scroll-top="scrollTop"
                @temporary-disable-button="data => (tempLoading = data)"
                :isInvoice="isInvoice"
                :invoiceItem="invoiceItem"
                :addNew="addNew"
                :isSaving="loading"
                :isDuplicate="isDuplicate"
            />
            <createRecordMultiplePatient
                v-if="
                    (isHasRecordPage || isTypeHasRecordPage) &&
                    isInvoice &&
                    !isSinglePatient
                "
                v-show="!isDataLoading && page == 'createRecordPage'"
                id="createRecordPage"
                ref="createRecordPage"
                @scroll-top="scrollTop"
                @loading="data => (loading = data)"
                :start-date="startDate"
                :modal-id="modalId"
                :isInvoice="isInvoice"
                :invoiceItem="invoiceItem"
                :isDuplicate="isDuplicate"
                :updateLot="updateLot"
            />
            <createRecord
                v-if="
                    (isHasRecordPage || isTypeHasRecordPage) &&
                    isInvoice &&
                    isSinglePatient
                "
                v-show="!isDataLoading && page == 'createRecordPage'"
                id="createRecordPage"
                ref="createRecordPage"
                @scroll-top="scrollTop"
                @loading="data => (loading = data)"
                :start-date="startDate"
                :modal-id="modalId"
                :isInvoice="isInvoice"
                :invoiceItem="invoiceItem"
                :isDuplicate="isDuplicate"
            />

            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs[modalId].hide('cancel')"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >

                <div class="float-right">
                    <img
                        v-if="loading || tempLoading"
                        src="assets/ajax-loader.gif"
                    />

                    <div v-else>
                        <b-button
                            v-if="page == 'createRecordPage'"
                            @click="back()"
                            variant="primary"
                            class="mr-2"
                            >Back</b-button
                        >

                        <b-button
                            v-if="
                                isInvoice &&
                                isHasRecordPage &&
                                isTypeHasRecordPage &&
                                page == 'createItemPage'
                            "
                            @click="next()"
                            class="float-right"
                            variant="primary"
                            :disabled="!canProceed || tempLoading"
                        >
                            {{ isButtonTextContinue ? "Continue" : "Next" }}
                        </b-button>

                        <b-button
                            v-else-if="!loading && isDuplicate"
                            class="float-right"
                            variant="primary"
                            @click="save(false)"
                            :disabled="isHasUsersChooseInvoice"
                            >Duplicate</b-button
                        >
                        <b-button-group v-else-if="!loading">
                            <b-dropdown
                                v-if="!addNew"
                                @click="save(false)"
                                left
                                split
                                text="Save + Done"
                                variant="primary"
                                :disabled="
                                    !canProceed ||
                                    tempLoading ||
                                    isHasUsersChooseInvoice
                                "
                            >
                                <b-dropdown-item @click="save(true)"
                                    >Save + Add New</b-dropdown-item
                                >
                            </b-dropdown>
                            <b-dropdown
                                v-else
                                @click="save(true)"
                                left
                                split
                                :text="`${
                                    isButtonTextContinue ? 'Continue' : 'Save'
                                } + Add New`"
                                variant="primary"
                                :disabled="
                                    !canProceed ||
                                    tempLoading ||
                                    isHasUsersChooseInvoice
                                "
                            >
                                <b-dropdown-item @click="save(false)">
                                    {{
                                        isButtonTextContinue
                                            ? "Continue"
                                            : "Save"
                                    }}
                                    + Done</b-dropdown-item
                                >
                            </b-dropdown>
                        </b-button-group>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { find, forEach, isArray, cloneDeep } from "lodash";
import LoaderList from "@/components/elements/loader-list";
import createItem from "@/components/invoice-item/create-item";
import createRecord from "@/components/invoice-item/create-record";
import createItemMultiplePatient from "@/components/invoice-item/create-item-multiple-patient";
import createRecordMultiplePatient from "@/components/invoice-item/create-record-multiple-patient";
import moment from "moment";
import ITEMTYPES from "@/constants/item-types";
import RecordService from "@/services/records";
import InvoiceItemServices from "@/services/invoice/invoice-item";
import EstimateItemServices from "@/services/estimate/estimate-item";
import RecordHelper from "@/mixins/record"; // for printLabel()
import ScheduleHelper from "@/module/schedule/helper"; // for _print_lab_order
import INVOICEITEM from "@/constants/invoice-item";

export default {
    name: "createUpdateInvoiceItemRecord",
    components: {
        createItem,
        createRecord,
        createItemMultiplePatient,
        createRecordMultiplePatient,
        LoaderList
    },
    mixins: [RecordHelper, ScheduleHelper],
    props: {
        isInvoice: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            page: "createItemPage",
            dataLoaded: false,
            modalId: "createUpdateRecord",
            continues: true,
            loading: true,
            editable: true,
            dataItem: null,
            dataRecord: null,
            isHasRecordPage: true, // If type 7 and 11, will dont have create record page
            isTypeHasRecordPage: true,
            addNew: false,
            invoiceItem: null,
            isDataLoading: true,
            canProceed: true,
            isButtonTextContinue: false,
            startDate: null,
            isDuplicate: false,
            tempLoading: false,
            isSinglePatient: false,
            updateLot: false
        };
    },
    watch: {},
    computed: {
        buttonTextSave() {
            return this.isButtonTextContinue ? "Continue" : "Save";
        },
        isNew() {
            return this.invoiceItem == null;
        },
        isEdit() {
            return !this.isNew;
        },
        title() {
            // return this.isNew ? "New Record" : "Edit Record";
            return this.isNew
                ? "New Record"
                : this.isDuplicate
                ? "Duplicate Record "
                : "Edit Record";
        },
        invoice() {
            return this.$store.getters["billing/invoiceDetails"];
        },
        estimate() {
            return this.$store.getters["billing/estimateDetails"];
        },
        isHasUsersChooseInvoice() {
            return this.warningMessagePayment !== "";
        },
        warningMessagePayment() {
            return this.invoice
                ? this.$store.getters["billing/warningMessagePayment"](
                      this.invoice.id
                  )
                : "";
        }
    },
    methods: {
        async open(invoiceItem = null, isDuplicate = false) {
            this.isSinglePatient = this.$route.query.multiple
                ? this.$route.query.multiple === "false"
                : false;
            if (this.isInvoice) {
                this.isDuplicate = isDuplicate;
                let date = this.invoice.start;
                if (invoiceItem && invoiceItem.is_editable == 1) {
                    // assets/js/module/billing/item.js | Line: 304 | function: edit
                    date = invoiceItem.date;
                    if (
                        invoiceItem.record &&
                        this._fromDateCarbon(invoiceItem.record.date) <
                            this._fromDateCarbon(invoiceItem.date)
                    ) {
                        date = invoiceItem.record.date;
                    }
                }

                // assets/js/module/billing/item.js | Line: 103 | function: add
                this.$store.dispatch("checkBillingLock", {
                    date: this._fromDateCarbon(date).toSeconds(),
                    onProceed: () => this.proceedBillingLock(invoiceItem),
                    onError: message => {
                        this.loading = false;
                        this._message(message, "danger");
                    }
                });
            } else {
                this.proceedBillingLock(invoiceItem);
            }
        },
        async proceedBillingLock(invoiceItem = null) {
            this.invoiceItem = invoiceItem;
            this.isDataLoading = true;

            // Load record details first if needed
            if (this.invoiceItem && this.invoiceItem.record_id) {
                this.invoiceItem.record_resource = await this.getRecordDetails(
                    this.invoiceItem.record_id
                );
            }

            this.$refs[this.modalId].show();
            this.startDate = moment().tz(this._timeZone); // used for NEW && DUPLICATE
            if (this.invoiceItem) {
                if (!this.isDuplicate) {
                    //DUPLICATE use create_at / now()
                    //Code below only applicable for EDIT
                    this.startDate = this.isInvoice
                        ? this._fromDateTime(
                              this._fromDateCarbon(this.invoiceItem.date),
                              "moment"
                          )
                        : this.invoiceItem.date;
                }
                // For lab will not create the record in this dialog
                this.isTypeHasRecordPage = ![
                    ITEMTYPES.TYPES.TYPE_OTHER_FEES,
                    ITEMTYPES.TYPES.TYPE_LAB
                ].includes(parseInt(this.invoiceItem.item.type));

                this.isHasRecordPage = this.invoiceItem.record != null;
            }

            this.isDataLoading = false;
            this.page = "createItemPage";
            this.$nextTick(() => {
                this.loading = false;
                this.$refs["createItemPage"].construct();
            });
            // this.getPrinterList(); // TODO : rather than retrieve printer each time next and back, we run it once in parent modal
        },
        getRecordDetails(recordId) {
            return RecordService.editRecordDetails(recordId).then(response => {
                return response;
            });
        },
        hidden() {},
        async next() {
            let valid = await this.copyDataItemAndValidate();

            if (valid) {
                this.page = "createRecordPage";
                this.$nextTick(() => {
                    this.$refs.createRecordPage.open(this.dataItem);
                });
            }
        },
        async back() {
            this.page = "createItemPage";
        },
        scrollTop() {
            // createUpdateRecord___BV_modal_body_ : the if of modal invoice-item/create-update
            const MODALBODYEL = document.getElementById(
                "createUpdateRecord___BV_modal_body_"
            );
            if (MODALBODYEL) {
                MODALBODYEL.scrollTo(0, 0);
            }
        },
        async copyDataItemAndValidate() {
            this.dataItem = cloneDeep(this.$refs.createItemPage.data);

            let valid = await this.$refs.createItemPage.validate();
            return valid;
        },
        checkItemNegativeError() {
            if (
                parseInt(this.dataItem.total_item_price) == 0 &&
                parseFloat(this.dataItem.unitPrice) < 0 &&
                this.dataItem.discountAmount == 100 &&
                this.dataItem.discountType == 0
            ) {
                // for negative item price should cannot proceed
                // but by applying the 100% discount or total amount discount to make total price 0
                // should make it error like in CI
                // if proceed, the invoice item become negative as the discount doesnt apply
                this._message("Error saving data", "danger");
                return true;
            }
            return false;
        },
        save(addNew) {
            this.isInvoice
                ? this.saveInvoice(addNew)
                : this.saveEstimate(addNew);
        },
        async saveEstimate(addNew) {
            let self = this;
            self.loading = true;
            // ESTIMATE ONLY HAS CREATE ITEM PAGE
            let valid = await this.copyDataItemAndValidate();
            if (!valid) {
                self.loading = false;
                return;
            }

            self.dataItem = cloneDeep(self.$refs.createItemPage.data);

            let params = {
                iitem_iid: self.estimate.id,
                iitem_pid:
                    self.dataItem.patients.length > 0
                        ? self.dataItem.patientId
                        : null,
                iitem_itemid: self.dataItem.item.id,
                iitem_start: this._now().toFormat(this._getLuxonFormat()),
                iitem_start_time: this._now().toFormat("h:mm a"),
                iitem_default_item_price:
                    self.dataItem.iitem_default_item_price,
                override_disc_status: self.dataItem.override_disc_status,
                is_min_price_tier: self.dataItem.is_min_price_tier,
                minimum_price: self.dataItem.minimum_price,
                minimum_price_type: self.dataItem.minimum_price_type,
                price_tier_min_id: self.dataItem.price_tier_min_id,
                price_tier_max_id: self.dataItem.price_tier_max_id,
                default_iitem_pid: self.dataItem.defaultIitemPid,
                iitem_fee_price: self.dataItem.iitem_fee_price,
                total_item_price_min: self.dataItem.total_item_price_min,
                total_item_price_max: self.dataItem.total_item_price_max,
                item_unit_price_min_ori: self.dataItem.iitem_min_unit_price_ori,
                item_unit_price_max_ori: self.dataItem.iitem_max_unit_price_ori,
                invoice_discount_id: self.dataItem.invoice_discount_id, // ask ras
                iitem_discount_id: self.dataItem.discountId,
                iitem_discount_amount: self.dataItem.discountAmount,
                iitem_discount_type: self.dataItem.discountType,
                iitem_bid: self.dataItem.provider
                    ? self.dataItem.provider.id
                    : null,
                iitem_quantity_min: self.dataItem.minQuantity,
                iitem_quantity_max: self.dataItem.maxQuantity,
                item_unit_price_min: self.dataItem.minUnitPrice,
                item_unit_price_max: self.dataItem.maxUnitPrice,
                iitem_fees: self.dataItem.fees.map(f => f.id),
                discount_id: self.dataItem.discountId,
                iitem_discount: self.dataItem.discountAmount,
                iitem_type: self.dataItem.discountType,
                iitem_tax: self.dataItem.taxes.map(t => t.id),
                iitem_print_on_invoice: Number(self.dataItem.isPrintOnInvoice),
                status: "0"
            };

            if (!this.isNew) {
                params["id"] = this.invoiceItem.id;
                params["iitem_id"] = this.invoiceItem.id;
                params["item_unit_price_min2"] = self.dataItem?.minUnitPrice2;
                params["item_unit_price_max2"] = self.dataItem?.maxUnitPrice2;
            }
            if (this.isNew) {
                this.proceedNewEstimateItem(params, addNew);
            } else {
                this.proceedEditEstimateItem(params, addNew);
            }
        },
        async proceedNewEstimateItem(params, addNew) {
            const response = await EstimateItemServices.postSave(params);
            this.responseSaveEstimateItem(response, addNew);
        },
        async proceedEditEstimateItem(params, addNew) {
            const response = await EstimateItemServices.postEdit(params);
            this.responseSaveEstimateItem(response, addNew);
        },
        async responseSaveEstimateItem(response, addNew) {
            let self = this;
            if (response && response.message && response.message.code == 200) {
                const RESOURCE = response.resource;

                self.addNew = addNew;
                if (self.addNew) {
                    if (self.$refs.createItemPage) {
                        await self.$refs.createItemPage.reset();
                    }
                    self.invoiceItem = null;
                    self.page = "createItemPage";
                    await this.$nextTick();
                    await self.$refs["createItemPage"].construct();
                    self.loading = false;
                } else {
                    self.loading = false;
                    self.$refs[this.modalId].hide();
                }

                if (RESOURCE.discount_alert) {
                    // the alert message not auto closed in CI
                    self._message(RESOURCE.discount_alert, "warning");
                } else {
                    self._message(RESOURCE.message, "success");
                }
                self.dataItem = null;
                self.dataRecord = null;
                this.$emit("reload");
            } else {
                self._message("Error", "danger");
                self.loading = false;
            }
        },
        soapIdsForPatient(patientId) {
            // add validation for patientId
            if (!patientId) {
                return null;
            }

            if (!Array.isArray(this.dataItem.soaps)) {
                this.dataItem.soaps = [this.dataItem.soaps];
            }
            if (
                !this.dataItem ||
                !Array.isArray(this.dataItem.soaps) ||
                this.dataItem.soaps.length === 0
            ) {
                return null;
            }

            return this.dataItem.soaps
                .filter(soap => soap.patientId === patientId)
                .map(soap => soap.id)
                .shift();
        },
        async saveInvoice(addNew) {
            let self = this;
            let customLots = [];
            let orderedPurchaseIDS = [];

            self.loading = true;

            if (
                this.page == "createRecordPage" &&
                self.$refs.createRecordPage
            ) {
                // HAVE BOTH CREATE ITEM PAGE AND CREATE RECORD PAGE
                // SCENARIO: CREATE INVOICE ITEM WITH TYPE EXCEPT FEE/LAB AND CREATE RECORD

                let valid = await self.$refs.createRecordPage.validate();

                if (!valid || self.checkItemNegativeError()) {
                    self.loading = false;
                    return;
                }
                self.dataRecord = cloneDeep(self.$refs.createRecordPage.data);

                // generate data custom lots
                if (self.dataRecord.lot && self.dataRecord.filled_by == 1) {
                    if (isArray(self.dataRecord.lot)) {
                        forEach(self.dataRecord.lot, function (lot) {
                            if (lot.value.search(":") > 0) {
                                customLots.push(JSON.parse(lot.value));
                            } else {
                                orderedPurchaseIDS.push(lot.value);
                            }
                        });
                    } else {
                        orderedPurchaseIDS.push(self.dataRecord.lot.value);
                    }
                }
            } else {
                // ONLY HAS CREATE ITEM PAGE
                // SCENARIO: CREATE INVOICE ITEM WITH
                // - TYPE FEE / LAB (FOR BOTH CREATE RECORD / DONT CREATE RECORD)
                // - TYPE EXCEPT FEE/LAB BUT "Dont Create Record" (Data do not have record)

                let valid = await this.copyDataItemAndValidate();
                if (!valid || self.checkItemNegativeError()) {
                    self.loading = false;
                    return;
                }

                self.dataItem = cloneDeep(self.$refs.createItemPage.data);

                self.dataRecord = {
                    diagnosis: [],
                    route: null,
                    location: null,
                    given_date:
                        this.isEdit && !this.isDuplicate
                            ? self._fromDateTime(
                                  self._fromDateCarbon(self.invoiceItem.date),
                                  "moment"
                              )
                            : self.startDate,
                    next_due: null,
                    record_note: null,
                    refill: 0,
                    expire: null,
                    filled_by: 1,
                    printer: self.dataItem.isShowPrinter
                        ? self.dataItem.printer
                        : "no",
                    print_quantity: self.dataItem.isShowPrinter
                        ? self.dataItem.print_quantity
                        : 1
                };

                if (
                    self.dataItem.item.due &&
                    (self.dataItem.item.due.label ||
                        self.dataItem.item.due.name)
                ) {
                    // DEFAULT TO GENERATE NEXT DUE
                    let dueName =
                        self.dataItem.item.due.name ||
                        self.dataItem.item.due.label;
                    let due = dueName.split(" ");

                    if (due.length == 2) {
                        let dueDate = this.startDate
                            ? this.startDate.clone().add(due[0], due[1])
                            : moment().tz(this._timeZone).add(due[0], due[1]);

                        self.dataRecord.next_due = dueDate.format(
                            this.getDateFormat()
                        );
                    }
                }

                if (
                    this.isHasRecordPage &&
                    self.dataItem.lot &&
                    self.dataRecord.filled_by == 1
                ) {
                    if (isArray(self.dataItem.lot)) {
                        forEach(self.dataItem.lot, function (lot) {
                            if (lot.value.search(":") > 0) {
                                customLots.push(JSON.parse(lot.value));
                            } else {
                                orderedPurchaseIDS.push(lot.value);
                            }
                        });
                    } else {
                        orderedPurchaseIDS.push(self.dataItem.lot.value);
                    }
                }
                if (this.isNew || this.isDuplicate) {
                    if (!this.isDuplicate) {
                        self.dataRecord.route = self.dataItem.item.route;
                        self.dataRecord.location = self.dataItem.item.location;
                    }
                }

                if (
                    (this.isEdit || this.isDuplicate) &&
                    self.invoiceItem.record_resource
                ) {
                    // edit invoice item with record (fee&lab)
                    const RECORD_RESOURCE = self.invoiceItem.record_resource
                        ? self.invoiceItem.record_resource.form_data
                              .record_resource
                        : null;

                    self.dataRecord.route = RECORD_RESOURCE.RouteID;
                    self.dataRecord.location = RECORD_RESOURCE.LocationID;
                    if (RECORD_RESOURCE.ReminderDate) {
                        self.dataRecord.next_due = moment
                            .unix(RECORD_RESOURCE.ReminderDate)
                            .format(self.getDateFormat());
                    }
                    self.dataRecord.record_note = RECORD_RESOURCE.RecordNote;
                    self.dataRecord.refill = RECORD_RESOURCE.Refill;
                }
            }

            let params = {
                item: self.dataItem.item.id,
                item_type: self.dataItem.itemType,
                purchase: "",
                quantity: self.dataItem.quantity,
                is_print_on_invoice: self.dataItem.isPrintOnInvoice ? 1 : 0,
                start: self.dataRecord.given_date
                    ? self.dataRecord.given_date.format(self.getDateFormat())
                    : this._now().toFormat(this._getLuxonFormat()),
                start_time: self.dataRecord.given_date
                    ? self.dataRecord.given_date.format("h:mm A")
                    : this._now().toFormat("h:mm a"),

                due: self.dataRecord.next_due
                    ? moment(
                          self.dataRecord.next_due,
                          self.getDateFormat()
                      ).format(self.getDateFormat())
                    : null,
                reminder: 1,
                record_note: self.dataRecord.record_note,
                clinic: self.dataRecord.filled_by,
                ordered_purchase_ids: orderedPurchaseIDS,
                custom_lots: customLots,

                tag: self.dataRecord.tag,
                microchip: self.dataRecord.microchip,
                route: self.dataRecord.route,
                location: self.dataRecord.location,
                refill: self.dataRecord.refill,
                expire: self.dataRecord.expire
                    ? moment(
                          self.dataRecord.expire,
                          self.getDateFormat()
                      ).format(self.getDateFormat())
                    : null,
                note: self.dataRecord.instruction,
                print_label: self.dataRecord.printer,
                print_quantity: self.dataRecord.print_quantity,
                iitem_iid: self.invoice.id,
                iitem_pid:
                    self.dataItem?.patients?.length > 0 &&
                    self.dataItem.patientId
                        ? self.dataItem.patientId
                        : null,
                iitem_price: self.dataItem.iitem_price,
                iitem_itemid: self.dataItem.item.id,

                iitem_plan_price: self.dataItem.iitem_plan_price,
                iitem_bid: self.dataItem.provider.id,
                iitem_start: self.dataRecord.given_date
                    ? self.dataRecord.given_date.format(self.getDateFormat())
                    : this._now().toFormat(this._getLuxonFormat()),
                iitem_start_time: self.dataRecord.given_date
                    ? self.dataRecord.given_date.format("h:mm A")
                    : this._now().toFormat("h:mm a"),

                iitem_default_item_price:
                    self.dataItem.iitem_default_item_price,
                override_disc_status: self.dataItem.override_disc_status,
                plan_item_balance: self.dataItem.plan_item_balance,
                is_plan_item: self.dataItem.is_plan_item ? 1 : 0,
                is_non_plan_item: self.dataItem.is_non_plan_item,
                iitem_unit_price_ori: self.dataItem.iitem_unit_price_ori,
                is_min_price_tier: self.dataItem.is_min_price_tier,
                minimum_price: self.dataItem.minimum_price,
                minimum_price_type: self.dataItem.minimum_price_type,
                price_tier_id: self.dataItem.price_tier_id,
                iitem_fee_price: self.dataItem.iitem_fee_price,
                invoice_discount_id: self.dataItem.invoice_discount_id,
                remove_invoice_discount: self.dataItem.remove_invoice_discount,

                iitem_discount_id: self.dataItem.discountId,
                iitem_discount_amount: self.dataItem.discountAmount,
                iitem_discount_type: self.dataItem.discountType,
                iitem_quantity: self.dataItem.quantity,
                iitem_unit_price: self.dataItem.unitPrice,
                iitem_fees: self.dataItem.fees.map(f => f.id),
                iitem_discount: self.dataItem.discountAmount,
                iitem_type: self.dataItem.discountType,
                iitem_tax: self.dataItem.taxes.map(t => t.id),
                iitem_print_on_invoice: self.dataItem.isPrintOnInvoice ? 1 : 0,
                iitem_create_record: self.dataItem.isHasRecordPage ? 1 : 0,
                iitem_actions: self.dataItem.action.map(a => a.value),
                printer_label: self.dataRecord.printer,
                diagnosis_ids: self.dataRecord.diagnosis.map(a => a.value),
                status: "1", // 1: invoice, 0: estimate, // TODO for estimate
                send_to_device: self.dataItem.send_to_device,
                source: self.dataItem.source,
                send_to: self.dataItem.send_to
            };

            // format iitem_pids
            let formattedItemPids = self.dataItem?.patients?.map(patient => {
                const planData =
                    self.dataItem?.patientPlanData?.patients?.find(
                        p => p.patient_id === patient.id
                    ) || {};
                // is_non_plan check with the default self.dataItem.is_non_plan_item as in set_plan_price the system will check if the selected discount is custom, then it will set the is_non_plan_item to false to avoid store the wellness_plan_id into the DB
                // if send is_non_plan_item to true, then BE will store the wellness_plan_id into the DB hence when edit, it auto select wellness plan discount
                return {
                    patient_id: patient.id,
                    soap_id: this.soapIdsForPatient(patient.id),
                    is_plan_item: planData?.is_plan || false,
                    is_non_plan_item: planData?.is_non_plan || false
                };
            });
            params["iitem_pids"] = formattedItemPids;

            if (this.soapIdsForPatient(self.dataItem.patientId) != -1) {
                params.iitem_soap_id = this.soapIdsForPatient(
                    self.dataItem.patientId
                );
            }

            if (!this.isNew && !this.isDuplicate) {
                params["id"] = this.invoiceItem.id;
                params["iitem_id"] = this.invoiceItem.id;
            }
            if (this.isNew || this.isDuplicate) {
                this.proceedNewInvoiceItem(params, addNew);
            } else {
                this.proceedEditInvoiceItem(params, addNew);
            }
        },
        async proceedNewInvoiceItem(params, addNew) {
            const response = await InvoiceItemServices.postSave(params);
            this.responseSaveInvoiceItem(response, addNew);
        },
        async proceedEditInvoiceItem(params, addNew) {
            let self = this;
            const responsePrecaculate = await InvoiceItemServices.precalculateItem(
                {
                    clinic: params.clinic,
                    discount_id: self.dataItem.discountId,
                    id: self.invoiceItem.id,
                    iitem_discount: params.iitem_discount,
                    iitem_fee_price: params.iitem_fee_price,
                    iitem_fees: params.iitem_fees,
                    iitem_id: self.invoiceItem.id,
                    iitem_iid: params.iitem_iid,
                    iitem_itemid: params.iitem_itemid,
                    iitem_pid: params.iitem_pid,
                    iitem_plan_price: params.iitem_plan_price,
                    iitem_price: params.iitem_price,
                    iitem_print_on_invoice: params.iitem_print_on_invoice,
                    iitem_quantity: params.iitem_quantity,
                    iitem_tax: params.iitem_tax,
                    iitem_type: params.iitem_type,
                    iitem_unit_price: params.iitem_unit_price,
                    iitem_unit_price_ori: params.iitem_unit_price_ori,
                    is_min_price_tier: params.is_min_price_tier,
                    is_non_plan_item: params.is_non_plan_item,
                    is_plan_item: params.is_plan_item,
                    minimum_price: params.minimum_price,
                    plan_item_balance: params.plan_item_balance,
                    price_tier_id: params.price_tier_id,
                    status: params.status
                }
            );
            if (
                responsePrecaculate &&
                responsePrecaculate.message &&
                responsePrecaculate.message.code == 200
            ) {
                const response = await InvoiceItemServices.postEdit(params);
                this.responseSaveInvoiceItem(response, addNew);
            } else {
                this.loading = false;
                this._message("Error", "danger");
            }
        },
        async responseSaveInvoiceItem(response, addNew) {
            let self = this;

            if (response && response.message && response.message.code == 200) {
                const RESOURCE = response.resource;

                if (
                    RESOURCE.lab_source == "ANTECH" &&
                    RESOURCE.lab_ids &&
                    RESOURCE.lab_ids.length > 0 &&
                    RESOURCE.accession_id &&
                    RESOURCE.antech_token
                ) {
                    self.$root.$emit("call-antech-iframe", {
                        accession_id: RESOURCE.accession_id,
                        antech_token: RESOURCE.antech_token
                    });
                } else if (
                    (RESOURCE.lab_ids && RESOURCE.lab_ids.length > 0) ||
                    RESOURCE.idexx_lab_id ||
                    RESOURCE.lab_id
                ) {
                    let print_lab_params = {
                        idexx_lab_id: RESOURCE.idexx_lab_id,
                        idexx_url: [RESOURCE.idexx_url],
                        lab_ids: RESOURCE.lab_ids,
                        source: RESOURCE.lab_source,
                        module: "appointment"
                    };

                    self._print_lab_order(print_lab_params).then(function (
                        lab_response
                    ) {
                        if (lab_response) {
                            if (lab_response.idexx_iframe) {
                                //load idexx iframe
                                lab_response.module_url =
                                    print_lab_params.module_url;
                                lab_response.module = print_lab_params.module;

                                self.$root.$emit(
                                    "call_idexx_iframe",
                                    lab_response
                                );
                            } else {
                                //load requisition form modal
                                lab_response.module_url =
                                    print_lab_params.module_url;
                                lab_response.module = print_lab_params.module;

                                self.$root.$emit(
                                    "call-multirequsition-modal",
                                    lab_response
                                );
                            }
                        }
                    });
                }

                if (self.dataRecord.printer !== "no") {
                    if (RESOURCE.iitem_response) {
                        forEach(RESOURCE.iitem_response, function (data) {
                            if (data) {
                                let dataLabel = {
                                    id: data.prescription_id,
                                    type: data.type,
                                    patient_id: data.patient_id,
                                    printer_id: data.printer_id,
                                    print_quantity: data.print_quantity
                                };
                                self.printLabel(dataLabel);
                            }
                        });
                    } else {
                        let dataLabel = {
                            id: RESOURCE.prescription_id,
                            type: RESOURCE.type,
                            patient_id: RESOURCE.patient_id,
                            printer_id: RESOURCE.printer_id,
                            print_quantity: RESOURCE.print_quantity
                        };
                        self.printLabel(dataLabel);
                    }
                }

                if (RESOURCE.action_response) {
                    forEach(RESOURCE.action_response, function (data) {
                        if (data && data.uri) {
                            window.open(data.uri);
                        }
                    });
                }

                self.addNew = addNew;

                if (self.addNew) {
                    self.loading = false;
                    self.$refs.createItemPage.reset();
                    if (self.$refs.createRecordPage) {
                        self.startDate = self.dataRecord.given_date;
                        await self.$refs.createRecordPage.reset();
                    }
                    self.invoiceItem = null;
                    self.page = "createItemPage";
                    await this.$nextTick();
                    await self.$refs["createItemPage"].construct();
                } else {
                    self.loading = false;
                    self.$refs[this.modalId].hide();
                }

                if (
                    RESOURCE.discount_alert ||
                    RESOURCE.iitem_response?.[0]?.discount_alert
                ) {
                    // the alert message not auto closed in CI
                    self._message(
                        RESOURCE.discount_alert
                            ? RESOURCE.discount_alert
                            : RESOURCE.iitem_response[0]?.discount_alert,
                        "warning"
                    );
                } else {
                    self._message(RESOURCE.message, "success");
                }
                self.dataItem = null;
                self.dataRecord = null;

                if (RESOURCE && RESOURCE.vetsource_url) {
                    let params = {
                        vetsourceLink: RESOURCE.vetsource_url,
                        itemId: RESOURCE.iitem_id
                    };
                    this.$emit("showVetsourceModal", params);
                }
                this.$emit("reload");
            } else if (
                response &&
                response.message &&
                response.message.code == 404
            ) {
                self.loading = false;
                self._message(response.resource, "danger");
                self.$nextTick(() => {
                    self.$refs[this.modalId].hide();
                    // incase of deleted invoice, redirect to billing dashboard
                    if (
                        response.error_code ==
                        INVOICEITEM.ERROR_MESSAGE.INVOICE_DELETED
                    ) {
                        self.$emit("redirect-to-dashboard");
                    } else if (
                        response.error_code ==
                        INVOICEITEM.ERROR_MESSAGE.INVOICE_WRITTEN_OFF
                    ) {
                        this.$emit("reload");
                    }
                });
            } else {
                self.loading = false;
                self._message("Error", "danger");
            }
        }
    }
};
</script>
<style type="text/css">
.create-invoice-item .form-group {
    margin-bottom: 1px !important;
}
</style>
